class ScrollBar {

    constructor() {

    return {
        restrict: "A",
        transclude: true,
        replace: true,
        template: '<div ng-transclude></div>',
        link: function($scope, $element, $attributes) {

            $element.slimScroll({height: "100%", wheelStep: 5});
            
            $(window).resize(function() {
                $element.slimScroll({height: "100%"});
            });
                                            
        }
    }; 

    }

}


angular.module('cpm')
    .directive('scrollBar', [() => {
        'use strict';
        return new ScrollBar();
    }]);
